import React from 'react';
import { Link } from 'react-router-dom';
import './Logo.css';

const Logo = () => {
  return (
    <Link to="/" className="app-logo">
      <img 
        src={`${process.env.PUBLIC_URL}/logo192.png`} 
        alt="Dress Desk" 
        className="app-logo-image" 
      />
    </Link>
  );
};

export default Logo;

